/**
 * 提交举报
 * @param resource_id 资源ID
 * @param resource_type 资源类型 0:文章, 1:视频, 2:图片, 3:动态, 4:评论, 5:用户, 6:私信, 7:弹幕
 * @param reason 举报原因
 * @param images 举报图片
 */
export async function requestReport(
  resource_id: number,
  resource_type: ResourceType,
  reason: string,
  images?: string[]
) {
  return http.post('/v1/reports/report', {
    resource_id,
    resource_type,
    reason,
    images
  })
}
